// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1XIzA","choiceBoxes":"toolbarselects_choiceBoxes__sh52p","simpleField":"toolbarselects_simpleField__1a1dN"};